import {
  Component,
  OnInit,
  ViewChild,
  TemplateRef,
  ElementRef,
  NgZone,
} from "@angular/core";
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormControl,
  ValidatorFn,
  AbstractControl,
} from "@angular/forms";
import { AdvtService } from "../../../_services/advt.service";
import { AlertService } from "../../../_services";
import { UploadFileService } from "../../../_services/upload-file.service";
import { BsModalService } from "ngx-bootstrap/modal";
import { BsModalRef } from "ngx-bootstrap/modal/bs-modal-ref.service";
import { Http } from "@angular/http";
import { } from "googlemaps";
import { MapsAPILoader } from "@agm/core";
import { environment } from "../../../../environments/environment";

@Component({
  selector: "app-post-graphics",
  templateUrl: "./post-graphics.component.html",
  styleUrls: ["./post-graphics.component.css"],
})
export class PostGraphicsComponent implements OnInit {
  @ViewChild("imageUploader") imgUploader: any;
  @ViewChild("videoUploader") videoUploader: any;
  @ViewChild("faceBook") faceBook: any;
  @ViewChild("address") public searchElementRef: ElementRef;
  @ViewChild('alertSizeModalTemplate') alertSizeModalTemplate: TemplateRef<any>;
  @ViewChild('alertVulgarTemplate') alertVulgarTemplate: TemplateRef<any>;

  // Modal
  modalRef: BsModalRef;
  isSellerCondition: boolean = true;
  // User Info
  userInfo = JSON.parse(localStorage.getItem("currentUser"));
  username = this.userInfo.result.username;
  user_id = this.userInfo.result.id;
  previewPop: boolean = true;
  sharePop: boolean = false;

  loading: boolean = false;
  listBidTypes: [number, string];
  addId;
  // Graph form
  graphForm: FormGroup;
  category_id = 2;

  theTitleLength: number = 0;

  // Image file prop
  imgUrl = new Array<any>();
  imgFileNameArray = [];
  imgFilePreviewArray = [];
  imgUrlLength: Boolean = true;
  imgUploadMsg: Boolean = false;
  imgs: any = [];
  itemId;

  // Video file prop
  vUrl;
  vFileName;
  vUploadMsg = false;
  allowvideoupload = true;

  // Show hide Image
  hideme = [];
  public latitude: number;
  public longitude: number;
  public zoom: number;
  public address: any;
  public addressfull: any;
  placeholder;
  PdfName;
  twitimage: any;
  instaimage: any;
  pinimage: any;
  telimage: any;
  snapimage: any;
  fbimage: any;
  placeholdervideo: any;
  placeholderimg: any;
  placeholderpdf: any;
  minLoader: any;
  MaxAmount;
  maxAmt;
  isDisabled: boolean = true;
  imagesplice = [];
  accessToken: string;
  public show: boolean = false;
  public buttonName: any = "Compare Bid";
  public ListCompareRate;
  showWarningMessage: string;
  warSameProduct: boolean = false;
  constructor(
    private fb: FormBuilder,
    private advtService: AdvtService,
    private modalService: BsModalService,
    private http: Http,
    private mapsAPILoader: MapsAPILoader,
    private ngZone: NgZone,
    private alertService: AlertService
  ) { }

  ngOnInit() {
    const userInfo = JSON.parse(localStorage.getItem('currentUser'));
    this.accessToken = userInfo.access_token;
    this.minLoader = "../../assets/images/smallLoader.gif";
    this.placeholder = "../../assets/images/imagePlaceholder.jpg";
    this.placeholdervideo = "../../assets/images/VPH.png";
    this.placeholderimg = "../../assets/images/IPH.png";
    this.placeholderpdf = "../../assets/images/PPH.png";
    this.fbimage = "../../assets/images/icon-1.png";
    this.twitimage = "../../assets/images/icon-2.png";
    this.instaimage = "../../assets/images/icon-3.png";
    this.pinimage = "../../assets/images/icon-4.png";
    this.telimage = "../../assets/images/icon-5.png";
    this.snapimage = "../../assets/images/icon-6.png";
    this.graphForm = this.fb.group({
      title: ["", [Validators.required, Validators.maxLength(150)]],
      type: ["", [Validators.required]],
      description: ["", [Validators.required, Validators.maxLength(1000)]],
      bid_type_id: ["", Validators.required],
      address: ["", [Validators.required]],
      //'escrow_service': ['', [Validators.required]],
      lat: [""],
      lng: [""],
      min_bid: ["", [Validators.required, Validators.maxLength(10)]],
      keywords: [""],
      preview_images: [""],
    });

    // Title input length count
    (this.graphForm.controls["title"] as FormControl).valueChanges.subscribe(
      (value) => {
        this.theTitleLength = value.length;
      }
    );
    this.getBidTypes();

    this.zoom = 15;

    //set current position
    this.setCurrentPosition();

    //load Places Autocomplete
    this.mapsAPILoader.load().then(() => {
      let autocomplete = new google.maps.places.Autocomplete(
        this.searchElementRef.nativeElement
      );
      autocomplete.addListener("place_changed", () => {
        this.ngZone.run(() => {
          //get the place result
          let place: google.maps.places.PlaceResult = autocomplete.getPlace();

          //verify result
          if (place.geometry === undefined || place.geometry === null) {
            return;
          }

          //set latitude, longitude and zoom
          this.latitude = place.geometry.location.lat();
          this.longitude = place.geometry.location.lng();
          this.addressfull = this.searchElementRef.nativeElement.value;
          this.zoom = 15;
        });
      });
    });
  }

  _checkNumPattern(event: any) {
    const pattern = /[0-9\+\.\ ]/;
    let inputChar = String.fromCharCode(event.charCode);

    if (!pattern.test(inputChar)) {
      // invalid character, prevent input
      event.preventDefault();
    }
  }

  /**
   * function to upload image
   * @param fileInput
   */


  imgfileChange(fileInput: any) {
    let media_type = "graphics";
    this.imgUrlLength = true;
    this.loading = true;

    for (let i = 0; i < fileInput.target.files.length; i++) {
      const singleFile = fileInput.target.files[i];

      this.advtService.AIimageScan(singleFile)
        .subscribe(
          (response: any) => {
            this.loading = true;
            if (response.data.issafe === 0) {
              this.advtService.onImageFileUpload(this.user_id, media_type, singleFile)
                .subscribe(
                  (data: any) => {
                    if (data.status === 413) {
                      this.loading = false;
                      const warningMessage = data.message
                      this.openVideoSizeModal(warningMessage);
                    }
                    else {
                      let ImgData: any = data.media_original_url;
                      let ImgPreievew: any = data.media_preview_url;

                      ImgData.map((item, index) => {
                        this.imgs.push({ imgURi: item });
                        this.imgFileNameArray.push(item);
                      });
                      ImgPreievew.map((item, index) => {
                        this.imgFilePreviewArray.push(item);
                      });
                      this.loading = false;
                      this.imgUrl = this.imgs;
                    }
                  },
                );
            } else if (response.data.issafe === 1) {
              this.loading = false;
              this.openAlertModal();
            }
          },
        );
    }
  }


  openAlertModal() {
    this.modalRef = this.modalService.show(this.alertVulgarTemplate);
  }

  /**
   *  function to delete image
   * @param filename (to send filename)
   * @param index (to splice data )
   */
  imgfileRemove(filename, index) {
    if (filename !== undefined) {
      this.imgUploadMsg = false;
      this.imgUploader.nativeElement.value = "";
      if (index != "video") {
        this.imagesplice.push(
          this.imgFileNameArray.splice(index, 1).toString()
        );
        this.imagesplice.push(
          this.imgFilePreviewArray.splice(index, 1).toString()
        );
        this.imgUrl.splice(index, 1);
        this.imgFileNameArray.splice(index, 1);
        this.imgFilePreviewArray.splice(index, 1);
      } else {
        this.vFileName = null;
        this.allowvideoupload = true;
      }
      var params = {
        filename: this.imagesplice,
      };
      this.advtService.deleteFile(params).subscribe((response) => { });
    }
  }

  /**
   *
   * @param fileInput
   * function to upload video
   */



  videofileChange(fileInput: any) {
    this.loading = true;
    let media_type = "videos"
    var reader = new FileReader();
    reader.onload = (e: any) => {
      this.vUrl = e.target.result;
    }
    reader.readAsDataURL(fileInput.target.files[0]);
    this.advtService.onFileUpload(this.user_id, media_type, fileInput)
      .subscribe(
        (data: any) => {
          if (data.status === 413) {
            this.loading = false;
            const warningMessage = data.message;
            this.openVideoSizeModal(warningMessage);
          }
          else {
            let ImgData: any = data.media_original_url;
            ImgData.map((item, index) => {
              this.vFileName = item;
            });
            this.videoUploader.nativeElement.value = "";
            this.loading = false;
            this.allowvideoupload = false;
          }
        });
  }

  onSubmit() {
    // this.isDisabled = false;
    this.graphForm.value.images = this.imgFileNameArray;
    this.graphForm.value.videos = this.vFileName;
    this.graphForm.value.category_id = this.category_id;
    this.graphForm.value.address = this.addressfull;
    this.graphForm.value.lat = this.latitude;
    this.graphForm.value.lng = this.longitude;
    this.graphForm.value.preview_images = this.imgFilePreviewArray;
    this.advtService.createNewItem(this.graphForm.value).subscribe(
      async (data) => {
        if (data.status === 409) {
          const warningMessage = data.message;
          await this.alertService.warning(warningMessage);
          this.warSameProduct = true;

        }
        else {
          this.addId = data;
          this.itemId = environment.apiUrl + "/item/item-detail/" + data.id;
          this.previewPop = false;
          this.sharePop = true;
          window.scrollTo(0, 0);
          this.loading = true;
          this.alertService.success("Added Successfully!");
          this.imgFilePreviewArray = [];
          this.addressfull = "";
          this.imgUrl = [];
          this.address = "";
          this.latitude = null;
          this.longitude = null;
          this.searchElementRef.nativeElement.value = "";
          this.vFileName = "";
          setTimeout(() => {
            this.graphForm.reset({
              title: "",
              description: "",
              bid_type_id: "",
              min_bid: "",
              keywords: "",
            });
          }, 500);
          this.loading = false;
        }
      },
      (error) => {
        this.alertService.error(error);
      }
    );
  }

  /**
   * function to Disbale Modal
   * @param event
   */
  _hidemodal(event: any) {
    this.modalRef.hide();
    this.previewPop = true;
    this.sharePop = false;
  }

  /**
   *
   *function to open model
   */
  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, { class: "gray modal-lg" })
    );
    let keywords = this.graphForm.value.keywords;
    let limit = 10;
    let offset = 0;
    this.advtService
      .getCompairRates(this.category_id, keywords, limit, offset)
      .subscribe(
        (data) => {
          this.ListCompareRate = data;
        },
        (error) => {
          this.alertService.error(error);
        }
      );
  }

  /**
   *
   *function to get Bid Types
   */
  public getBidTypes() {
    this.advtService.getBidTypes().subscribe(
      (data) => {
        this.listBidTypes = data;
      },
      (error) => {
      }
    );
  }

  /**
   * function to Disable Space
   * @param event
   */
  _checkSPace(event: any) {
    //this.durCheck = regexp.test(event.target.value)
    if (event.which === 32 && event.target.selectionStart === 0) {
      return false;
    }
  }

  /**
   * function to get current position
   */
  private setCurrentPosition() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.latitude = position.coords.latitude;
        this.longitude = position.coords.longitude;
        this.zoom = 15;
      });
    }
  }

  toggle() {
    this.show = !this.show;
    // CHANGE THE NAME OF THE BUTTON.
    if (this.show) this.buttonName = "Hide Bid";
    else this.buttonName = "Compare Bid";
  }

  _checkMaxNumber(searchValue: any) {
    this.MaxAmount = 970873.77;
    if (Number(this.MaxAmount) <= searchValue) {
      this.maxAmt = true;
    } else {
      this.maxAmt = false;
    }
  }

  public onChangeTerms(is_terms): void {
    this.isSellerCondition = !is_terms.target.checked ? true : false;
  }
  CancelButton() {
    this.modalRef.hide();
  }

  openVideoSizeModal(message: string) {
    this.showWarningMessage = message;
    this.modalRef = this.modalService.show(this.alertSizeModalTemplate);
  }

}



// WEBPACK FOOTER //
// ./src/app/authorized-data/post-graphics-listing/post-graphics/post-graphics.component.ts